import React from 'react';
import './CustomLabel.css';

export const CustomLabel = (props) => {
  return (
    <div className="CustomLabel" data-tip={props.text}>
      <div className="CustomLabel_ImgLeft">{props.img && <img src={props.img} alt="" />}</div>
      <div className="CustomLabel_TextContainer">
        {props.text && <div className="CustomLabel_TextString">{props.text}</div>}
      </div>
    </div>
  );
};

